<template>
  <div
    class="d-flex tw-gap-[10px]"
    style="max-height: 560px; min-height: 560px"
  >
    <BaseLoader v-if="loadingsStateComponent.main"></BaseLoader>
    <!-- основной - первый блок -->
    <div class="tw-bg-white tw-p-[8px_15px] tw-rounded-[8px] tw-w-[27.52%]">
      <div v-if="!loadingsStateComponent.main">
        <!-- основные данные -->
        <div class="tw-text-[11px] tw-font-[600] tw-text-forTitle">
          <span v-if="!dataForTab.clients__is_ur_face">{{
            dataLang["clients_register_text_15"]
          }}</span>
          <span v-if="dataForTab.clients__is_ur_face">{{
            dataLang["clients_register_text_155"]
          }}</span>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-[5px]">
          <div ref="clients__ur_inn" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__ur_inn"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__ur_inn"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_159']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__email" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__email"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__email"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_18']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__phone">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              v-if="dataForTab.clients__is_ur_face"
              input-name="clients__phone"
              @input="updateValue"
              :horizontalTitle="true"
              inputRef="clients__phone"
              maxLength="16"
              inputMask="+{7}(000)000-00-00"
              :value="dataForTab.clients__phone"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_164']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__name">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              class="tw-leading-[13px]"
              input-name="clients__name"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__name"
              :name-sign="
                !dataForTab.clients__is_ur_face
                  ? dataLang['clients_register_text_16']
                  : dataLang['clients_register_text_156']
              "
            >
            </BaseInputNew>
          </div>
          <div ref="clients__ur_fio" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__ur_fio"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__ur_fio"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_157']"
            >
            </BaseInputNew>
          </div>
          <div
            ref="clients__ur_action_on"
            v-if="dataForTab.clients__is_ur_face"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              class="tw-leading-[13px]"
              input-name="clients__ur_action_on"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__ur_action_on"
              :additionalParams="{}"
              :name-sign="dataLang['form_ur__vehicle_owners_ur__acts_on']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__ur_kpp" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__ur_kpp"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__ur_kpp"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_160']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__ur_ogrn" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__ur_ogrn"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__ur_ogrn"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_161']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__rs" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__rs"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__rs"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_162']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__bank" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__bank"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__bank"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_25']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__bik" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__bik"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__bik"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_24']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__ur_ks" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__ur_ks"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__ur_ks"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_163']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__phone" v-if="!dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__phone"
              @input="updateValue"
              :horizontalTitle="true"
              inputRef="clients__phone"
              maxLength="16"
              inputMask="+{7}(000)000-00-00"
              :value="dataForTab.clients__phone"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_131']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__email" v-if="!dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__email"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__email"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_18']"
            >
            </BaseInputNew>
          </div>
          <div
            ref="clients__fiz_date_birth"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__fiz_date_birth"
              @input="updateValue"
              :horizontalTitle="true"
              maxLength="10"
              inputMask="00.00.0000"
              :value="checkDate(dataForTab?.clients__fiz_date_birth)"
              :additionalParams="{
                dateInput: true,
              }"
              :name-sign="dataLang['clients_register_text_19']"
            >
            </BaseInputNew>
          </div>
          <div
            ref="clients__fiz_place_birth"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__fiz_place_birth"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__fiz_place_birth"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_20']"
            >
            </BaseInputNew>
          </div>
          <div
            ref="clients__fiz_passport"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__fiz_passport"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__fiz_passport"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_21']"
            >
            </BaseInputNew>
          </div>
          <div
            ref="clients__fiz_place_of_residence"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__fiz_place_of_residence"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__fiz_place_of_residence"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_22']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__garant_fio" v-if="dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              input-name="clients__garant_fio"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__garant_fio"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_16']"
            >
            </BaseInputNew>
          </div>
          <div
            ref="clients__garant_phone"
            v-if="dataForTab.clients__is_ur_face"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small tw-w-full tw-max-w-[185px]"
              signClass="!tw-text-lightText"
              class="tw-leading-[13px]"
              input-name="clients__garant_phone"
              @input="updateValue"
              :horizontalTitle="true"
              inputRef="clients__garant_phone222"
              maxLength="16"
              inputMask="+{7}(000)000-00-00"
              :value="dataForTab.clients__garant_phone"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_172']"
            >
            </BaseInputNew>
          </div>
        </div>
        <!-- основные данные -->

        <!-- Реквизиты -->
        <div
          v-if="!dataForTab.clients__is_ur_face"
          class="tw-text-[11px] tw-font-[600] tw-text-forTitle tw-mt-[8px]"
        >
          {{ dataLang["clients_register_text_23"] }}
        </div>
        <div class="tw-flex tw-flex-col tw-gap-[5px]">
          <div ref="clients__rs" v-if="!dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
              signClass="!tw-text-lightText"
              placeholder=""
              width="210"
              input-name="clients__rs"
              inputRef="clients__garant_phone222222"
              maxLength="15"
              inputMask="000000000000000"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__rs"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_1299']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__bik" v-if="!dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
              signClass="!tw-text-lightText"
              placeholder=""
              width="210"
              input-name="clients__bik"
              inputRef="clients__garant_phone22222"
              maxLength="15"
              inputMask="000000000000000"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__bik"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_24']"
            >
            </BaseInputNew>
          </div>
          <div ref="clients__bank" v-if="!dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
              signClass="!tw-text-lightText"
              placeholder=""
              width="210"
              input-name="clients__bank"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__bank"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_25']"
            >
            </BaseInputNew>
          </div>
        </div>
        <!-- Реквизиты -->

        <!-- Ближайшее контактное лицо -->

        <div
          v-if="!dataForTab.clients__is_ur_face"
          class="tw-text-[11px] tw-font-[600] tw-text-forTitle tw-mt-[8px]"
        >
          {{ dataLang["clients_register_text_26"] }}
        </div>
        <div class="tw-flex tw-flex-col tw-gap-[5px]">
          <div ref="clients__garant_fio" v-if="!dataForTab.clients__is_ur_face">
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
              signClass="!tw-text-lightText"
              placeholder=""
              width="210"
              input-name="clients__garant_fio"
              @input="updateValue"
              :horizontalTitle="true"
              :value="dataForTab.clients__garant_fio"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_16']"
            >
            </BaseInputNew>
          </div>
          <div
            ref="clients__garant_phone"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
              signClass="!tw-text-lightText"
              placeholder=""
              width="210"
              input-name="clients__garant_phone"
              @input="updateValue"
              :horizontalTitle="true"
              inputRef="clients__garant_phone2"
              maxLength="16"
              inputMask="+{7}(000)000-00-00"
              :value="dataForTab.clients__garant_phone"
              :additionalParams="{}"
              :name-sign="dataLang['clients_register_text_17']"
            >
            </BaseInputNew>
          </div>
        </div>
        <!-- Ближайшее контактное лицо -->

        <!-- Свидетельство на право управления транспортом -->
        <div
          v-if="!dataForTab.clients__is_ur_face"
          class="tw-text-[11px] tw-font-[600] tw-text-forTitle tw-mt-[8px] tw-mb-[3px]"
        >
          {{ dataLang["clients_register_text_27"] }}
        </div>
        <div class="tw-flex tw-flex-col tw-gap-[5px]">
          <div
            class="tw-grid tw tw-grid-cols-[6fr_5fr_4fr] tw-gap-[5px] tw-items-center"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <div ref="clients__fiz_doc_vu_number">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText !tw-whitespace-nowrap"
                placeholder=""
                width="75"
                input-name="clients__fiz_doc_vu_number"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_vu_number"
                :additionalParams="{}"
                :name-sign="dataLang['clients_register_text_28']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_vu_date">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="71"
                input-name="clients__fiz_doc_vu_date"
                @input="updateValue"
                :horizontalTitle="true"
                inputRef="vehicles__sts_date3"
                inputMask="00.00.0000"
                maxLength="10"
                :value="checkDate(dataForTab?.clients__fiz_doc_vu_date)"
                :additionalParams="{}"
                :name-sign="dataLang['clients_register_text_32']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_vu_year">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="44"
                input-name="clients__fiz_doc_vu_year"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_vu_year"
                :additionalParams="{}"
                inputRef="clients__fiz_do2c_vu_year"
                inputMask="0000"
                maxLength="4"
                :name-sign="dataLang['clients_register_text_33']"
              >
              </BaseInputNew>
            </div>
          </div>
          <div
            class="tw-grid tw tw-grid-cols-[6fr_5fr_4fr] tw-gap-[5px] tw-items-center"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <div ref="clients__fiz_doc_ppla_number">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText !tw-whitespace-nowrap"
                placeholder=""
                width="75"
                input-name="clients__fiz_doc_ppla_number"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_ppla_number"
                :additionalParams="{}"
                :name-sign="dataLang['clients_register_text_29']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_ppla_date">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="71"
                input-name="clients__fiz_doc_ppla_date"
                @input="updateValue"
                :horizontalTitle="true"
                inputRef="vehicle2s__sts_date"
                inputMask="00.00.0000"
                maxLength="10"
                :value="checkDate(dataForTab?.clients__fiz_doc_ppla_date)"
                :additionalParams="{}"
                :name-sign="dataLang['clients_register_text_32']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_ppla_year">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="44"
                input-name="clients__fiz_doc_ppla_year"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_ppla_year"
                :additionalParams="{}"
                inputMask="0000"
                inputRef="clients__fiz33_do2c_vu_year"
                maxLength="4"
                :name-sign="dataLang['clients_register_text_33']"
              >
              </BaseInputNew>
            </div>
          </div>
          <div
            class="tw-grid tw tw-grid-cols-[6fr_5fr_4fr] tw-gap-[5px] tw-items-center"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <div ref="clients__fiz_doc_pplh_number" class="wp-100">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText !tw-whitespace-nowrap"
                placeholder=""
                width="75"
                input-name="clients__fiz_doc_pplh_number"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_pplh_number"
                :additionalParams="{}"
                :name-sign="dataLang['clients_register_text_30']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_pplh_date">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="71"
                input-name="clients__fiz_doc_pplh_date"
                @input="updateValue"
                :horizontalTitle="true"
                inputMask="00.00.0000"
                inputRef="vehicles__sts_da2te"
                maxLength="10"
                :value="checkDate(dataForTab?.clients__fiz_doc_pplh_date)"
                :additionalParams="{}"
                :name-sign="dataLang['clients_register_text_32']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_pplh_year">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="44"
                input-name="clients__fiz_doc_pplh_year"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_pplh_year"
                :additionalParams="{}"
                inputMask="0000"
                inputRef="clients__fiz_do2c_v2u_year"
                maxLength="4"
                :name-sign="dataLang['clients_register_text_33']"
              >
              </BaseInputNew>
            </div>
          </div>
          <div
            class="tw-grid tw tw-grid-cols-[6fr_5fr_4fr] tw-gap-[5px] tw-items-center"
            v-if="!dataForTab.clients__is_ur_face"
          >
            <div ref="clients__fiz_doc_gims_number" class="wp-100">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText !tw-whitespace-nowrap"
                placeholder=""
                width="75"
                input-name="clients__fiz_doc_gims_number"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_gims_number"
                :additionalParams="{}"
                :name-sign="dataLang['clients_register_text_31']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_gims_date">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="71"
                input-name="clients__fiz_doc_gims_date"
                @input="updateValue"
                :horizontalTitle="true"
                :value="checkDate(dataForTab?.clients__fiz_doc_gims_date)"
                :additionalParams="{}"
                inputMask="00.00.0000"
                inputRef="vehicles__sts_da3te"
                maxLength="10"
                :name-sign="dataLang['clients_register_text_32']"
              >
              </BaseInputNew>
            </div>
            <div ref="clients__fiz_doc_gims_year">
              <BaseInputNew
                inputClass="tw-app-input-type-2 tw-app-input-type-2-small"
                signClass="!tw-text-lightText"
                placeholder=""
                width="44"
                input-name="clients__fiz_doc_gims_year"
                @input="updateValue"
                :horizontalTitle="true"
                :value="dataForTab.clients__fiz_doc_gims_year"
                :additionalParams="{}"
                inputMask="0000"
                inputRef="clients__1fiz_do2c_vu_year"
                maxLength="4"
                :name-sign="dataLang['clients_register_text_33']"
              >
              </BaseInputNew>
            </div>
          </div>
        </div>
        <!-- Свидетельство на право управления транспортом -->
      </div>
    </div>
    <!-- основной - первый блок -->

    <!-- второй блок - статистика -->
    <div
      class="tw-bg-white tw-p-[8px_15px] tw-rounded-[8px] tw-text-[11px] tw-w-[15.64%] tw-flex tw-flex-col tw-justify-between"
    >
      <div>
        <div class="tw-font-[600] tw-text-forTitle">
          {{ dataLang["clients_register_text_37"] }}
        </div>
        <div class="tw-text-forTitle">(локальная/ глобальная)</div>

        <div v-for="section in mockStatData" class="tw-my-[8px]">
          <div class="tw-font-[600] tw-text-forTitle">{{ section.title }}:</div>
          <div
            v-for="item in section.options"
            class="tw-flex tw-justify-between"
          >
            <div class="tw-text-forText">{{ item }}:</div>
            <div class="tw-text-forTitle">0/0*</div>
          </div>
        </div>
      </div>

      <div
        class="tw-p-[12px_8px] tw-text-forTitle tw-text-center tw-border-solid tw-border-[1px] tw-border-[#000] tw-rounded-[5px] tw-leading-[13px]"
      >
        Запросить глобальную блокировку
      </div>
    </div>
    <!-- второй блок - статистика -->

    <!-- третий блок -->
    <div
      class="tw-bg-white tw-p-[8px_15px] tw-rounded-[8px] tw-text-[11px] tw-text-forTitle tw-w-[27.85%] tw-flex tw-flex-col tw-justify-between"
    >
      <div class="tw-flex tw-gap-[10px] flex-col tw-text-center">
        <div class="tw-w-full">
          <div class="tw-font-[600] tw-mb-[5px]">
            {{ dataLang["clients_register_text_108"] }}
          </div>
          <div
            class="tw-p-[12px] tw-rounded-[3px] tw-text-[14px] tw-font-[600] tw-text-white"
            :style="{
              'background-color':
                dataForTab.clients__balance > -1 ? '#23B14D' : '#FF2400',
            }"
          >
            {{ dataForTab.clients__balance?.replace(".", ",") || 0 }}
          </div>
        </div>
        <div class="tw-w-full">
          <div class="tw-font-[600] tw-mb-[5px]">Бонусов</div>
          <div
            class="tw-border-[1px] tw-border-solid tw-border-[#DCE0ED] tw-p-[12px] tw-text-[14px] tw-rounded-[3px] tw-font-[600]"
          >
            100
          </div>
        </div>
        <div class="tw-w-full">
          <div class="tw-font-[600] tw-mb-[5px]">LTV</div>
          <div
            class="tw-border-[1px] tw-border-solid tw-border-[#DCE0ED] tw-p-[12px] tw-text-[14px] tw-rounded-[3px] tw-font-[600]"
          >
            5000
          </div>
        </div>
        <div class="tw-w-full">
          <div class="tw-font-[600] tw-mb-[5px]">
            {{ dataLang["clients_register_text_43"] }}
          </div>
          <div
            class="tw-border-[1px] tw-border-solid tw-border-[#DCE0ED] tw-p-[12px] tw-text-[14px] tw-rounded-[3px] tw-font-[600] tw-whitespace-nowrap"
          >
            <span
              class="fw-bold"
              v-if="dataForTab.statistics?.daysAfterLastOrder !== -1"
            >
              {{ dataForTab.statistics?.daysAfterLastOrder }}
              {{ dataLang["clients_register_text_44"] }}
            </span>
            <span class="fw-bold" v-else>
              {{ dataLang["clients_register_text_1555"] }}
            </span>
          </div>
        </div>
      </div>

      <!-- пресеты перезвона -->
      <div>
        <div class="tw-font-[600] tw-mb-[5px] tw-mt-[10px]">
          {{ dataLang["clients_register_text_53"] }}
        </div>
        <div class="tw-flex tw-gap-[10px] tw-whitespace-nowrap">
          <button
            @click="sendPerezvon('hour')"
            class="tw-app-btn-secondary !tw-text-[11px] !tw-px-[10px] !tw-w-full !tw-justify-center"
          >
            Через час
          </button>
          <button
            @click="sendPerezvon('day')"
            class="tw-app-btn-secondary !tw-text-[11px] !tw-px-[10px] !tw-w-full !tw-justify-center"
          >
            Через сутки
          </button>
          <button
            @click="$modal.show('selectTime')"
            class="tw-app-btn-secondary !tw-text-[11px] !tw-px-[10px] !tw-w-full !tw-justify-center"
          >
            Выбрать время
          </button>
        </div>
        <div class="tw-text-forText tw-mt-[10px] tw-text-center">
          {{ dataLang["clients_register_text_56"] }}
        </div>
      </div>
      <!-- пресеты перезвона -->

      <hr class="tw-border-[1px] tw-border-[#899AB4] tw-my-[10px]" />

      <!-- отправить смс пресет -->
      <div>
        {{ dataLang["clients_register_text_57"] }}
        <div class="tw-flex tw-gap-[10px] tw-mb-[8px]">
          <div class="multiselect-type-2 tw-w-full">
            <BaseSelect
              placeholder=""
              selectLabel=""
              deselectLabel=""
              @input="(data) => (senderSmsPreset = data)"
              v-model="dataFromSelect.sms_presets"
              :options="selectsOptions.presets"
              label="sms_presets__name"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template
              ><template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>
          <button @click="sendSms" class="tw-app-btn-secondary">Отпр.</button>
        </div>

        {{ dataLang["clients_register_text_59"] }}
        <div class="tw-flex tw-gap-[10px]">
          <div class="multiselect-type-2 tw-w-full">
            <BaseInputNew
              inputClass="tw-app-input-type-2"
              input-name="someSmsToSend"
              maxLength="500"
              @input="({ value }) => (someSmsToSend = value)"
              :horizontalTitle="true"
              :value="someSmsToSend"
            >
            </BaseInputNew>
          </div>
          <button @click="sendSmsSome" class="tw-app-btn-secondary">
            Отпр.
          </button>
        </div>
        <div class="tw-text-forText tw-pl-[66%]">
          {{ someSmsToSend.length }}/500
        </div>
      </div>
      <!-- отправить смс пресет -->

      <hr class="tw-border-[1px] tw-border-[#899AB4] tw-my-[10px]" />

      <!-- желтые кнопки -->
      <div>
        <button
          class="tw-app-btn-warning tw-mb-[8px] !tw-w-full !tw-justify-center"
        >
          Проверить клиента через СБ-1
        </button>
        <button class="tw-app-btn-warning !tw-w-full !tw-justify-center">
          Обновить скоринг клиента
        </button>
      </div>
      <!-- желтые кнопки -->

      <hr class="tw-border-[1px] tw-border-[#899AB4] tw-my-[10px]" />

      <!-- аренда без экипажа -->
      <div
        class="tw-relative tw-flex tw-items-center tw-gap-[10px] tw-bg-[#213960] tw-rounded-[3px] tw-p-[10px]"
        ref="clients__is_pledge_only"
      >
        <BaseCheckboxV2
          class="tw-bg-white tw-rounded-[3px]"
          input-name="clients__is_pledge_only"
          v-model="dataForTab.clients__is_pledge_only"
          signClass="d-none"
          @oncheckeds="updateValue"
        >
        </BaseCheckboxV2>
        <div class="tw-text-white">
          Аренда без экипажа
          <div class="tw-text-[10px]">
            {{ dataLang["clients_register_text_50"] }}
          </div>
        </div>
        <img
          :src="require(`@/assets/icons/locklight.svg`)"
          height="12"
          class="tw-absolute tw-right-[10px] tw-top-[10px]"
        />
      </div>
      <!-- аренда без экипажа -->

      <hr class="tw-border-[1px] tw-border-[#899AB4] tw-my-[10px]" />

      <!-- ачивки? -->
      <div class="tw-grid tw-grid-cols-3 tw-gap-[5px_8px]">
        <div
          v-for="item in achievements"
          class="tw-flex tw-gap-[3px] tw-items-center tw-justify-center tw-bg-[#F1F3F5] tw-border-solid tw-border-[1px] tw-rounded-[5px] tw-border-[#DCE0ED] tw-text-[#899AB4] tw-p-[4px]"
        >
          <img :src="item.icon" height="12" />
          {{ item.title }}
        </div>
      </div>
      <!-- ачивки? -->
    </div>
    <!-- третий блок -->

    <!-- 4 блок - комментарии -->
    <div
      class="tw-relative tw-bg-white tw-p-[8px_15px] tw-rounded-[8px] tw-text-[11px] tw-w-[26.38%]"
    >
      <div class="tw-text-forTitle">
        <BaseLoader v-if="loadingsStateComponent.comment"></BaseLoader>
        <div class="tw-text-[12px]">
          {{ dataLang["vehicles_page__modal__tab_comments__name"] }}
        </div>
        <div class="tw-flex tw-gap-[10px] tw-items-center tw-mt-[10px]">
          <BaseInputNew
            class="tw-w-full"
            inputClass="tw-app-input-type-2"
            input-name="newComment"
            @input="(data) => (newCommentValue = data)"
            :horizontalTitle="true"
            ref="commentInput"
          >
          </BaseInputNew>
          <button
            class="tw-app-btn-primary !tw-bg-[#F1F3F5] !tw-px-[9px]"
            @click="sendComment"
          >
            <img
              :src="require(`@/assets/icons/add-dark.svg`)"
              width="8"
              height="8"
            />
          </button>
        </div>

        <BaseScrollbar style="max-height: 480px" class="tw-mt-[10px]">
          <div class="comments">
            <div class="comments-base d-flex flex-column gap-10">
              <div
                v-for="(comment, index) of commentsList"
                :key="comment.client_comments__id"
                class="comment d-flex gap-5 justify-content-between tw-border-solid tw-border-[1px] tw-border-[#DCE0ED] tw-rounded-[3px]"
              >
                <div class="comment-info d-flex flex-column gap-0">
                  <p
                    class="comment-info__heading tw-text-forText fw-normal fsc-11 lh-sm m-0"
                  >
                    {{
                      $time(comment.client_comments__created_at)
                        .utc(true)
                        .utcOffset(Number(userSetting.company__utc))
                        .format(`${userSetting.company__tempalte_date} HH:mm`)
                    }}
                  </p>
                  <p
                    class="comment-info__content fsc-12 lh-sm m-0 tw-text-forTitle"
                  >
                    {{ comment.client_comments__comment }}
                  </p>
                </div>

                <div class="comment-actions d-flex h-100 tw-gap-[3px]">
                  <div
                    :class="[]"
                    class="comment-actions__pin d-flex justify-content-center align-items-center rounded-5 cursor-pointer"
                    @click="
                      () => {
                        fixComment(
                          comment.client_comments__id,
                          !comment.client_comments__is_fixed
                        );
                        comment.client_comments__is_fixed =
                          !comment.client_comments__is_fixed;
                      }
                    "
                  >
                    <img
                      v-if="!comment.client_comments__is_fixed"
                      :src="require(`@/assets/comments/pin.svg`)"
                      width="16"
                      height="16"
                    />
                    <img
                      v-if="comment.client_comments__is_fixed"
                      :src="require(`@/assets/comments/pin-green.svg`)"
                      width="16"
                      height="16"
                    />
                  </div>
                  <div
                    class="comment-actions__delete d-flex justify-content-center align-items-center cursor-pointer"
                    @click="delComment(comment.client_comments__id)"
                  >
                    <img
                      :src="require(`@/assets/comments/close.svg`)"
                      width="16"
                      height="16"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BaseScrollbar>
      </div>
    </div>
    <!-- 4 блок - комментарии -->

    <gallery :images="images" :index="index" @close="index = null"></gallery>

    <BaseModal
      name="acceptChangeWithPin"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="pincodeModalHandler"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptChangeWithPin')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-app-modal__title">Внимание!</div>

          <div class="tw-my-[15px]">
            Вы внесли изменение, требующее пароля администратора. Введите этот
            пароль или изменение не применится.
          </div>

          <BaseInputNew
            inputClass="tw-app-input-type-3"
            placeholder=""
            :input-name="'pincode'"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptChangeWithPin')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="sendData"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="selectTime"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="() => (selectTime = [])"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('selectTime')"
        ></button>
        <div>
          <div class="tw-app-modal__title">Выберите время</div>

          <BaseDatePicker
            class="!tw-w-full"
            inputClass="tw-app-input-type-3"
            v-model="selectTime"
            type="datetime"
            lang="ru"
            id="vehicle_tiwres__bought_at"
            time-title-format="DD.MM.YYYY"
            value-type="format"
            :format="`${userSetting.company__tempalte_date} HH:mm`"
          >
          </BaseDatePicker>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('selectTime')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="sendPerezvon('custom')"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import UploadFileWithPreview from "@/components/UploadFileWithPreview.vue";
import GeneralService from "@/api/GeneralService";
import MainTab from "./MainTab.vue";
import SelectsService from "@/api/SelectsService.js";
import EventBus from "@/event-bus.js";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import StorageFileService from "@/api/StorageFileService";
import VueGallery from "vue-gallery";
export default {
  components: {
    VueTabs,
    VTab,
    MainTab,
    UploadFileWithPreview,
    gallery: VueGallery,
  },

  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      achievements: [
        {
          title: "GCL",
          icon: require("@/assets/achievements/gcl.svg"),
          activeIcon: require("@/assets/achievements/gcl-a.svg"),
          activeColor: "#0C63AA",
          activeBackground: "#E3F0FF",
        },
        {
          title: "SR 0",
          icon: require("@/assets/achievements/sr.svg"),
          activeIcon: require("@/assets/achievements/sr-a.svg"),
          activeColor: "#114BD4",
          activeBackground: "#E3F0FF",
        },
        {
          title: "ГЧС",
          icon: require("@/assets/achievements/gbl.svg"),
          activeIcon: require("@/assets/achievements/gbl-a.svg"),
          activeColor: "#FF3A20",
          activeBackground: "#FFEFF4",
        },
        {
          title: "СБ-1",
          icon: require("@/assets/achievements/sb-1.svg"),
          activeIcon: require("@/assets/achievements/sb-1-a.svg"),
          activeColor: "#666666",
          activeBackground: "#F5F5F5",
        },
        {
          title: "СБ-2",
          icon: require("@/assets/achievements/sb-2.svg"),
          activeIcon: require("@/assets/achievements/sb-2-a.svg"),
          activeColor: "#23B14D",
          activeBackground: "#E8FEEE",
        },
        {
          title: "SC:0",
          icon: require("@/assets/achievements/sc.svg"),
          activeIcon: require("@/assets/achievements/sc-a.svg"),
          activeColor: "#000",
          activeBackground: "#E7E7E7",
        },
      ],
      selectTime: [],
      pincode: "",
      signsGallery: [
        "Паспорт 1 разв.",
        "Паспорт 2 разв.",
        "Селфи с паспортом",
        "В/У лицо",
        "В/У оборот",
        "PPL (A)",
        "PPL (H)",
        "ГИМС",
      ],
      images: [],
      index: null,
      dataFromSelect: {
        orders__type_rent: [],
        ads: [],
        objects_types: [],
        orders__body_generation: [],
        loadingsStateComponent: [],
        cities__end_name: [],
        cities__start_name: [],
        sms_presets: [],
        client: [],
      },
      dataFromSelect: {
        orders__type_rent: [],
        ads: [],
        objects_types: [],
        orders__body_generation: [],
        loadingsStateComponent: [],
        cities__end_name: [],
        cities__start_name: [],
        sms_presets: [],
        client: [],
      },
      selectsOptions: {},
      senderSmsPreset: {},
      updatedValues: {},
      dataForTab: {},
      tabInfo: this.modalInfo,
      newCommentValue: {},
      messageError: [],
      galleryList: [
        {
          clients_documents__client_id: null,
          clients_documents__document_key: "clients_documents__image_1",
          clients_documents__image_1: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 1,
        },
        {
          clients_documents__client_id: 9,
          clients_documents__document_key: "clients_documents__image_2",
          clients_documents__image_2: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 2,
        },
        {
          clients_documents__client_id: null,
          clients_documents__document_key: "clients_documents__image_3",
          clients_documents__image_3: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 3,
        },
        {
          clients_documents__client_id: null,
          clients_documents__document_key: "clients_documents__image_4",
          clients_documents__image_4: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 4,
        },
        {
          clients_documents__client_id: null,
          clients_documents__document_key: "clients_documents__image_5",
          clients_documents__image_5: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 5,
        },
        {
          clients_documents__client_id: null,
          clients_documents__document_key: "clients_documents__image_6",
          clients_documents__image_6: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 6,
        },
        {
          clients_documents__client_id: null,
          clients_documents__document_key: "clients_documents__image_7",
          clients_documents__image_7: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 7,
        },
        {
          clients_documents__client_id: null,
          clients_documents__document_key: "clients_documents__image_8",
          clients_documents__image_8: "",
          clients_documents__file: "",
          clients_documents__id: null,
          client_document_types__position: 8,
        },
      ],
      someSmsToSend: "",

      loadingsStateComponent: {
        comment: false,
        deferred: false,
        main: false,
      },
      //   modalInfo: {
      //     modalOpened: false,
      //     id: null,
      //     loading: true
      //   },
      commentsList: [],
      mockStatData: [
        {
          title: "Аренд без экипажа",
          options: [
            "Легковой",
            "Коммерческий",
            "Мото",
            "Автодома",
            "Прицепы",
            "Спецтехника",
            "Водный",
            "Воздушный",
          ],
        },
        {
          title: "Аренд с экипажем",
          options: [
            "Легковой",
            "Коммерческий",
            "Мото",
            "Автодома",
            "Прицепы",
            "Спецтехника",
            "Водный",
            "Воздушный",
          ],
        },
        {
          title: "Итого",
          options: [
            "Аренд",
            "Километраж б/э",
            "Штрафов",
            "Инцидентов",
            "Ущербов",
          ],
        },
      ],
    };
  },
  methods: {
    checkDate(date) {
      if (date) {
        return date.split("-").reverse().join(".");
      } else {
        return "";
      }
    },
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      // this.loadingsStateComponent.main = true
      if (this.updatedValues?.clients__fiz_date_birth) {
        this.updatedValues.clients__fiz_date_birth =
          this.updatedValues.clients__fiz_date_birth
            .split(".")
            .reverse()
            .join("-");
      } else {
        delete this.updatedValues.clients__fiz_date_birth;
      }
      if (this.updatedValues?.clients__fiz_doc_ppla_date) {
        this.updatedValues.clients__fiz_doc_ppla_date =
          this.updatedValues.clients__fiz_doc_ppla_date
            .split(".")
            .reverse()
            .join("-");
      } else {
        delete this.updatedValues.clients__fiz_doc_ppla_date;
      }
      if (this.updatedValues?.clients__fiz_doc_pplh_date) {
        this.updatedValues.clients__fiz_doc_pplh_date =
          this.updatedValues.clients__fiz_doc_pplh_date
            .split(".")
            .reverse()
            .join("-");
      } else {
        delete this.updatedValues.clients__fiz_doc_pplh_date;
      }
      if (this.updatedValues?.clients__fiz_doc_vu_date) {
        this.updatedValues.clients__fiz_doc_vu_date =
          this.updatedValues.clients__fiz_doc_vu_date
            .split(".")
            .reverse()
            .join("-");
      } else {
        delete this.updatedValues.clients__fiz_doc_vu_date;
      }
      if (this.updatedValues?.clients__fiz_doc_gims_date) {
        this.updatedValues.clients__fiz_doc_gims_date =
          this.updatedValues.clients__fiz_doc_gims_date
            .split(".")
            .reverse()
            .join("-");
      } else {
        delete this.updatedValues.clients__fiz_doc_gims_date;
      }
      if (Object.keys(this.updatedValues).length) {
        GeneralService.edit(
          `/clients/${this.modalInfo.id}`,
          Object.assign(this.updatedValues, {
            ...(this.pincode && { pincode: this.pincode }),
          })
        )
          .then((data) => {
            this.$toast.success(data.data.message);

            EventBus.$emit("contentLoaded");
            EventBus.$emit("updateContentData");
            // this.loadingsStateComponent.main = false
            this.$modal.hide("acceptChangeWithPin");
            callback(true, nameTab, oldTab, newTab, flagIsClose);
          })
          .catch((e) => {
            // this.loadingsStateComponent.main = false
            if (e.response.status == 409) {
              this.$modal.show("acceptChangeWithPin", { type: "change" });
              this.messageError = e.response.data.message;
              this.$toast.error(e.response.data.message, { duration: 5000 });
              callback(false, nameTab, oldTab, newTab);
            } else if (e.response.status == 400) {
              setTimeout(() => {
                Object.keys(e.response.data.errors).forEach((elem, index) => {
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
              }, 10);
              this.$modal.hide("acceptDeleteWithPin");
              this.$toast.error(e.response.data.message, { duration: 5000 });
              callback(false, nameTab, oldTab, newTab);
            }
          });
      } else {
        EventBus.$emit("contentLoaded");
        EventBus.$emit("updateContentData");
        callback(true, "", oldTab, newTab, flagIsClose);
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
      this.messageError = "";
    },
    loadfile(params) {
      this.loadingsStateComponent.main = true;

      this.loadingState = true;
      params.fileInFormData.append("type", "client_anketa");
      StorageFileService.upload(params.fileInFormData)
        .then((data) => {
          this.galleryList[params.keyData - 1][params.doc_key] =
            data.data.data.url;
          GeneralService.edit(`/clients/${this.tabInfo.id}`, {
            documents: [
              {
                [params.doc_key]: data.data.data.id,
              },
            ],
          }).then((data) => {
            this.$toast.success(data.data.message);
            this.loadingsStateComponent.main = false;
            this.loadingMainInfo();
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
    removefile(params) {
      this.loadingsStateComponent.main = true;
      this.galleryList[params.keyData - 1].client_blacklist_gallery__file = "";
      GeneralService.delete(
        `/clients/${this.tabInfo.id}/document/${params.doc_key}`
      )
        .then((data) => {
          this.loadingsStateComponent.main = false;
          this.loadingMainInfo();
          // this.loadMainInfo()
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
    clickOnImage(index) {
      this.index = index;
    },
    sendSmsSome() {
      console.log(
        this.updatedValues.clients__phone || this.dataForTab.clients__phone
      );
      if (this.dataForTab.clients__phone || this.updatedValues.clients__phone) {
        GeneralService.editOrCreate(`/sms`, {
          phone:
            this.updatedValues.clients__phone || this.dataForTab.clients__phone,
          text: this.someSmsToSend,
          // (this.dataForTab.clients__phone || this.updatedValues.clients__phone)
        })
          .then((data) => {
            this.$toast.success(data.data.message);
            this.someSmsToSend = "";
            this.modalInfo.loading = false;
            // EventBus.$emit('closeModal')
            EventBus.$emit("contentLoaded");
            EventBus.$emit("updateContentData");
          })
          .catch((err) => {
            this.$toast.error(err.response.data.message, { duration: 5000 });
            this.someSmsToSend = "";
          });
      }
    },
    sendPerezvon(type) {
      let date;
      if (type == "day") {
        date = this.$time()
          .utc(true)
          .utcOffset(Number(this.userSetting.company__utc))
          .add(1, "day")
          .format(`YYYY-MM-DD HH:mm:ss`);
      } else if (type == "custom") {
        date = this.$time(
          this.selectTime.split(" ")[0].split(".").reverse().join("-") +
            " " +
            this.selectTime.split(" ")[1]
        )
          .utc(true)
          .utcOffset(Number(this.userSetting.company__utc))
          .format(`YYYY-MM-DD HH:mm:ss`);
      } else {
        date = this.$time()
          .utc(true)
          .utcOffset(Number(this.userSetting.company__utc))
          .add(1, "hour")
          .format(`YYYY-MM-DD HH:mm:ss`);
      }
      GeneralService.edit(`/clients/${this.modalInfo.id}`, {
        clients__next_call_date: date,
      })
        .then((data) => {
          this.$toast.success(data.data.message);
          this.modalInfo.loading = false;
          this.selectTime = [];
          EventBus.$emit("closeModal");
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
        })
        .catch((e) => {
          console.error(e);
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 });
          } else {
            this.$toast.error("Ошибка", { duration: 5000 });
          }
        });
    },

    loadComments() {
      GeneralService.get(`/clients/${this.modalInfo.id}/comments`)
        .then((data) => {
          this.commentsList = data.data.data.rows;
          this.loadingsStateComponent.comment = false;
        })
        .catch((e) => {});
    },
    sendSms() {
      if (
        (this.dataForTab.clients__phone || this.updatedValues.clients__phone) &&
        Object.values(this.senderSmsPreset).length
      ) {
        this.loadingsStateComponent.deferred = true;

        GeneralService.editOrCreate(`/sms`, {
          phone:
            this.dataForTab.clients__phone || this.updatedValues.clients__phone,
          text: this.senderSmsPreset.sms_presets__text,
          type: "client",
          id: this.modalInfo.id,
          preset: this.senderSmsPreset.sms_presets__name,
        })
          .then((data) => {
            // this.selects.push(data.data.data.rows)
            this.$toast.success(data.data.message);

            this.dataFromSelect.sms_presets = [];
            this.senderSmsPreset = {};
            this.loadingsStateComponent.deferred = false;

            this.loadComments();
          })
          .catch((e) => {});
      } else {
        this.$toast.error("Не введен номер телефона или не выбран пресет", {
          duration: 5000,
        });
      }
    },
    delComment(id) {
      GeneralService.delete(`/clients/${this.modalInfo.id}/comments/${id}`)
        .then((data) => {
          // this.selects.push(data.data.data.rows)
          this.$toast.success(data.data.message);
          this.loadingsStateComponent.comment = false;
          this.loadComments();
        })
        .catch((e) => {});
    },
    fixComment(id, fix) {
      GeneralService.edit(`/clients/${this.modalInfo.id}/comments/${id}`, {
        client_comments__is_fixed: fix,
      })
        .then((data) => {
          // this.selects.push(data.data.data.rows)
          this.$toast.success(data.data.message);
          this.loadingsStateComponent.comment = false;
          this.loadComments();
          this.newCommentValue = {};
        })
        .catch((e) => {});
    },
    sendComment() {
      if (this.newCommentValue?.value) {
        this.loadingsStateComponent.comment = true;
        GeneralService.editOrCreate(`/clients/${this.modalInfo.id}/comments`, {
          client_comments__comment: this.newCommentValue.value,
        })
          .then((data) => {
            // this.selects.push(data.data.data.rows)
            this.$toast.success(data.data.message);
            this.loadingsStateComponent.comment = false;
            this.loadComments();
            this.newCommentValue = {};

            this.$refs.commentInput.$el.querySelector("input").value = "";
          })
          .catch((e) => {});
      } else {
        this.$toast.error("Напишите комментарий", { duration: 5000 });
      }
    },
    beforeClose() {
      this.updatedValues = {};
      this.dataForModal = {};
      this.modalInfo.modalOpened = false;
      for (const key in this.dataFromSelect) {
        this.dataFromSelect[key] = [];
      }
      this.dateForDeferredOrder = [];
      for (const key in this.dataForDatePicker) {
        this.dataForDatePicker[key] = [];
      }
      this.mainObject = "";
      this.clientName = "";
      this.finishCost = 0;
      // this.$refs.objectName.$el.querySelector(input).textContent = ''
      this.diffByDate = 0;
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
      // if (data.name == 'clients__phone') {
      //   clearTimeout(this.timeout)
      //   this.timeout = setTimeout(() => this.findClientInfo(data.value), 2000)
      // }
      // if (data.name == 'orders__vehicle_id') {
      //   this.dataForModal.orders__vehicle_id = data.value
      //   clearTimeout(this.timeout)
      //   this.timeout = setTimeout(
      //     () => this.findObjectAndOrderInfo(data.value),
      //     2000
      //   )
      // }
      // if (this.$refs[data.name]) {
      //   this.$refs[data.name].classList.remove('input-error')
      // }
    },
    setSimpleSelect(data, name) {
      if (this.$refs[name]) {
        this.$refs[name].classList.remove("input-error");
      }

      this.updatedValues[name ? name : data.key] = data.value;

      delete this.updatedValues.clients_types_face;
      if (name == "orders__vehicle_type") {
        // /selects/body-generation/{vehicleTypeId}
        GeneralService.get(
          `/selects/body-generation/${data.fallback}?orderBy=vehicles_body_generation__position&orderDir=ASC`
        )
          .then((data) => {
            this.selectsOptions = Object.assign(this.selectsOptions, {
              car_body_type: data.data.data.rows,
            });
          })
          .catch((e) => {});
      }
      if (data.key == "clients_types_face") {
        this.updatedValues.clients__is_ur_face =
          data.value == "clients_type_fiz" ? false : true;
        this.dataForModal.clients__is_ur_face =
          data.value == "clients_type_fiz" ? false : true;
      }
      if (this.$refs[data.key]) {
        this.$refs[data.key].classList.remove("input-error");
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    loadingMainInfo() {
      this.loadingsStateComponent.main = true;
      Promise.all([
        GeneralService.get(
          `/clients/${this.tabInfo.id}?joins=statistics,verifications,documents`
        )
          .then((data) => {
            this.dataForTab = data.data.data.rows[0];
            this.galleryList.forEach((element, index) => {
              let indexed = data.data.data.rows[0].documents.findIndex(
                (x) =>
                  x.client_document_types__position ==
                  element.client_document_types__position
              );
              if (indexed >= 0) {
                this.galleryList[index] =
                  data.data.data.rows[0].documents[indexed];
              }
            });
            this.galleryList.forEach((element, index) => {
              this.images.push(element.clients_documents__file);
            });
          })
          .catch((e) => {}),
        GeneralService.get(`/presets/sms`, {
          params: {
            where: JSON.stringify([
              { field: "sms_presets__category_id", value: 2 },
            ]),
          },
        })
          .then((data) => {
            Object.assign(this.selectsOptions, {
              presets: data.data.data.rows,
            });
          })
          .catch((e) => {}),
      ]).then(() => {
        EventBus.$emit("finishLoad");
        this.loadingsStateComponent.main = false;
      });
    },
  },
  mounted() {},
  created() {
    this.loadComments();
    this.loadingMainInfo();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>
